import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
@Component({
  selector: 'app-area',
  templateUrl: './area.component.html',
  styleUrls: ['./area.component.scss']
})
export class AreaComponent implements OnInit {

  constructor( 
    public authService: AuthService,
    public router: Router) { }

  ngOnInit() {
    this.ls_area();
  }
  area:any;
  ls_area(){
    let postData = {}
    this.authService.service("/api/get_area",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {
          console.log(res);
          this.area=data;
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });  

}

}
